@mixin stack-rules {
    .grid {
        flex-direction: column;
        align-items: center;
        gap: var(--spacer-32);
    }

    .tile {
        width: 100%;
        align-items: center;
    }

    .spacer {
        display: none;
    }
}

.gridWrap {
    composes: safeContainer from "../../styles/composable/layout.module.css";
    container-type: inline-size;
    container-name: small-link-tiles;
}

.gridWrapTwo {
    composes: gridWrap;

    @container small-link-tiles (max-width: 700px) {
        @include stack-rules;
    }
}

.gridWrapThree {
    composes: gridWrap;

    @container small-link-tiles (max-width: 900px) {
        @include stack-rules;
    }
}

.grid {
    display: flex;
    justify-content: center;
}

.tile {
    flex: 1 0 25%;
    max-width: 420px;
    display: flex;
    gap: var(--labui-grid-gap);
    align-items: flex-start;
    justify-content: space-between;
}

.text {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: var(--spacer-8);
}

.heading {
    font: var(--font-p-18);
}

.cta {
    margin-top: var(--spacer-8);
    font: var(--font-text-link-12);
    text-decoration: underline;
}

.imageWrapper {
    flex: 0 0 45%;
    aspect-ratio: 69 / 53;
    overflow: hidden;
}

.image {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.spacer {
    width: 1px;
    height: auto;
    margin-inline: var(--spacer-24);
    background-color: var(--gray-500);
    flex-shrink: 0;
}
